import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { classes } from './utils';

export type SidebarButtonProps = {
  href: string;
  label: string;
  renderIcon: (className: string) => ReactNode;
};

export default function SidebarButton({
  href,
  label,
  renderIcon,
}: SidebarButtonProps) {
  const pathname = usePathname();
  const isActive = pathname.includes(href);

  return (
    <Link
      href={href}
      className={twMerge(
        classes.button,
        isActive ? classes.active : classes.inactive
      )}>
      <span className={classes.iconWrapper}>{renderIcon(classes.icon)}</span>
      <span className={classes.label}>{label}</span>
    </Link>
  );
}
